<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">캐시충전</h2>
                <div class="page-text grey--text text--darken-1 mt-1">핀번호를 입력하여 나누리 캐시로 교환하실 수 있습니다.</div>
            </div>

            <v-divider class="d-md-none" />
            <div class="py-20px pt-md-0px pb-md-40px text-center">
                <div class="tit tit--xs">
                    <b class="black--text">{{ me?.name }}</b
                    >님의 나누리 캐시
                </div>
                <div class="mb-3 mt-1">
                    <b class="tit tit--lg primary--text font-weight-bold">{{ parseInt(+me?.cash || 0).format() }}</b> 원
                </div>
                <v-row align="center" justify="center" class="row--x-small mt-20px mt-md-30px">
                    <v-col cols="auto">
                        <v-btn color="primary" outlined to="/mypage/cashes/give"><v-icon size="20" class="mr-2">mdi-gift</v-icon>선물하기</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" outlined to="/mypage/cashes/gift"><v-icon size="20" class="mr-2">mdi-text-box-search</v-icon>선물내역</v-btn>
                    </v-col>
                </v-row>
            </div>

            <v-card color="grey lighten-4" elevation="0" class="px-12 py-8">
                <v-card-title class="tit tit--sm primary--text">
                    핀번호 입력
                    <v-spacer />
                    <div class="page-text grey--text text--darken-4 text-right mt-10px">성공: {{ success }}개, 실패: {{ failed }}개</div>
                </v-card-title>
                <v-card-text>
                    <v-row class="row--small">
                        <template v-for="(item, index) in pins">
                            <v-col cols="12" md="9" :key="`${index}-form`">
                                <v-text-field v-model="item.pno" flat dense solo hide-details placeholder="20자리" />
                            </v-col>
                            <v-col cols="12" md="3" :key="`${index}-done`">
                                <v-text-field v-model="item.result" flat dense solo placeholder="충전결과" hide-details disabled />
                            </v-col>
                        </template>
                        <v-col cols="12">
                            <template v-if="charged">
                                <v-btn x-large text block :disabled="loading" @click="refresh">
                                    <span class="font-weight-bold"> 초기화 </span>
                                    <v-icon class="ml-2" size="20">mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <template v-else>
                                <v-btn x-large text block :disabled="loading" @click="addField">
                                    <span class="font-weight-bold"> 입력란 추가 </span>
                                    <v-icon class="ml-2" size="20">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <div v-if="amount && !$vuetify.breakpoint.mobile" class="py-10px py-md-16px">
                <v-row justify="center" class="font-size-14 font-size-md-16 grey--text text--darken-3 text-center">
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">이전 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(+me?.cash || 0).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                    <v-col cols="auto">+</v-col>
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">충전 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(amount).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                    <v-col cols="auto">=</v-col>
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">충전 후 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(me.cash + amount).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div v-if="amount && $vuetify.breakpoint.mobile" class="v-data-table v-data-table--sm theme--light v-data-table--mobile">
                <div class="v-data-table__wrapper">
                    <table>
                        <tbody>
                            <tr class="v-data-table__mobile-table-row">
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">이전 캐시</div>
                                    <div class="v-data-table__mobile-row__cell">
                                        <span>{{ parseInt(+me?.cash || 0).format() }}원</span>
                                    </div>
                                </td>
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">충전 캐시</div>
                                    <div class="v-data-table__mobile-row__cell">
                                        <span>{{ parseInt(amount).format() }}원</span>
                                    </div>
                                </td>
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">충전 후 캐시</div>
                                    <div class="v-data-table__mobile-row__cell">
                                        <span>{{ parseInt(me.cash + amount).format() }}원</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="py-20px py-md-40px">
                <v-row class="row--small" justify="center">
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                        <v-btn rounded large color="primary" class="white--text w-160px" :loading="loading" :disabled="loading || charged" @click="charge">
                            <span> 충전하기 </span>
                        </v-btn>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                        <v-btn rounded large outlined color="primary" class="w-160px border-3" to="/mypage/cashes/inquiry">
                            <span class="black--text"> 충전내역 조회 </span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <v-divider />

        <v-card elevation="0" class="py-20px py-md-40px">
            <v-card-title class="tit tit--sm primary--text pt-0">
                <v-row justify="end" align="center">
                    <v-col cols="auto">
                        대량 교환하기
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                        <v-btn large color="grey" class="my-n3" @click="sampleDownload">
                            <span> 샘플 다운로드 </span>
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn large color="primary" class="my-n3" :disabled="loading" @click="$refs.uploader.$refs.input.click()">
                            <span> 대량 업로드 </span>
                        </v-btn>
                        <v-file-input ref="uploader" class="d-none" @change="(file) => upload(file)" />
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="py-20px py-md-40px">
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="">
                        <v-row class="row--xx-small">
                            <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-1.svg"/></v-col>
                            <v-col>
                                <p class="page-text page-text--small line-height-13 min-h-lg-54px">위에 ‘샘플다운로드’ 버튼을 눌러 대량 업로드용 양식을 다운받습니다.</p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="">
                        <v-row class="row--xx-small">
                            <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-2.svg"/></v-col>
                            <v-col>
                                <p class="page-text page-text--small line-height-13 min-h-lg-54px">도서교환권이 있는 첫번째 줄은 수정하지 않고 두번째 줄부터 핀을 입력합니다.</p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="">
                        <v-row class="row--xx-small">
                            <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-3.svg"/></v-col>
                            <v-col>
                                <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일을 저장 후 위에 ‘대량 업로드’ 버튼을 눌러 저장한 파일을 업로드합니다.</p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="">
                        <v-row class="row--xx-small">
                            <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-4.svg"/></v-col>
                            <v-col>
                                <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일 업로드 후 ‘충전하기’ 버튼을 누르면 완료됩니다.</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-divider />

        <v-layout justify-center>
            <v-card elevation="0" class="py-20px py-md-40px">
                <v-card-title class="tit tit--sm primary--text pt-0">
                    <span>유의사항</span>
                </v-card-title>
                <v-card-text>
                    <ul class="disc-list">
                        <li>20자리 상품권 PIN 번호를 입력하여 충전하실 수 있습니다.</li>
                        <li>상품권 PIN 번호를 10회 이상 잘못 입력 시, ID 로그아웃 및 차단 상태로 변경됩니다.</li>
                        <li>불법적인 방법으로 충전, 도용 시 법적 제재를 받습니다.</li>
                        <li>상품권 PIN 번호 입력 후 캐시 충전 시 취소가 불가 합니다.</li>
                        <li>유효기간은 발행일로부터 5년입니다.</li>
                    </ul>
                </v-card-text>
            </v-card>
        </v-layout>
    </component>
</template>
<script>
import api from "@/api";
import XLSX from "xlsx";
import download from "downloadjs";
import { mdiGift, mdiRefresh, mdiTextBoxSearch, mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiHelpCircleOutline } from "@mdi/js";
import PnoField from "@/components/client/pin/pno-field.vue";
export default {
    components: {
        PnoField,
    },
    data() {
        return {
            mdiGift,
            mdiRefresh,
            mdiTextBoxSearch,
            mdiMicrosoftExcel,
            mdiHelpCircleOutline,
            mdiPlusCircleMultipleOutline,

            me: null,

            pins: [{ pno: null, result: null }],
            pinsHeaders: [
                { text: "핀번호", value: "pno", align: "center" },
                { text: "충전결과", value: "result", align: "center", width: 200 },
            ],

            amount: 0,
            success: 0,
            failed: 0,
            charged: false,
            loading: false, // 충전 요청 진행중 여부 (중복 제출 차단용)
        };
    },
    mounted() {
        if (this.logoff) {
            this.$router.push(`/login`);
            return;
        }

        this.init();
    },
    methods: {
        download,
        async init() {
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        },
        addField() {
            this.pins.push({ pno: null, result: null });
        },
        async charge() {
            ////////////////////////////////////////////////////////////////////
            // 중복 제출 차단 (이중 충전 방지)
            // 버튼 disabled 는 화면이 다시 그려진 뒤에야 적용되므로, 같은 이벤트
            // 턴에 클릭이 두 번 잡히면 뚫린다. 첫 await 이전에 동기적으로 잠근다.
            ////////////////////////////////////////////////////////////////////
            if (this.loading) return;

            if (!this.pins.find((pin) => !!pin.pno)) {
                alert("핀번호를 입력해주세요");
                return;
            }

            this.loading = true;

            try {
                for (var pin of this.pins) {
                    if (!pin.pno) continue;
                    let { success, message, amount } = await api.v1.me.cashes.charge(pin);
                    if (message === "캐시 충전 10회 실패로 인하여 ID 접근 차단 및 로그아웃 처리되었습니다. \n재로그인 시 본인인증을 진행하셔야 합니다.") {
                        alert(message);
                        this.$store.dispatch("logout");
                    }

                    if (amount) {
                        this.amount = this.amount + amount;
                    }

                    this.$set(pin, "result", message);
                    success ? this.success++ : this.failed++;
                }
                setTimeout(() => {
                    if (this.success) {
                        alert("충전되었습니다");
                        // this.init();
                    }
                }, 500);
                this.charged = true;
            } finally {
                this.loading = false;
            }
        },
        refresh() {
            let go = confirm("입력란을 초기화하시겠습니까?\n핀번호 및 충전 결과가 모두 지워집니다.");
            if (!go) return;
            this.pins = [];
            this.$nextTick((_) => (this.pins = [{ pno: null, result: null }]));
            this.charged = false;
            this.success = 0;
            this.failed = 0;
            this.amount = 0;
            this.init();
        },
        upload(file) {
            if (!file) return;
            let fileName = file.name.split(".");
            if (fileName[fileName.length - 1] !== "xlsx") {
                return alert("엑셀파일만 가능합니다");
            }
            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach((sheetName) => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });

                this.pins = [];
                let index = 0;
                for (let row of workSheets[0]) {
                    if (row["도서교환권"].length !== 20) {
                        alert("핀번호를 확인해주세요");
                        this.$router.go();
                    }
                    let pno = row["도서교환권"];
                    this.$set(this.pins, index++, { pno: pno?.replace(/[^0-9A-Z]/g, ""), result: null });
                }
            };
            reader.readAsBinaryString(file);
        },
        sampleDownload() {
            api.getResource("/assets/sample.xlsx").then((file) => download(file, "샘플다운로드.xlsx"));
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        logoff() {
            return !this.accessToken;
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.banner-link-wrap {
    position: relative;
}
.banner-link {
    position: absolute;
    width: 50%;
    height: 30%;
    z-index: 2;
    bottom: 0;
}
.banner-link1 {
    left: 0;
}
.banner-link2 {
    right: 0;
}
.disc-list {
    list-style: disc;
    padding-left: 16px;

    & > li::marker {
        font-size: 0.5em;
    }
}
@media (min-width: 960px) {
    .banner-link {
        width: 189px;
        height: 44px;
        bottom: 15px;
    }
    .banner-link1 {
        left: 31px;
    }
    .banner-link2 {
        right: 31px;
    }
}
</style>
